import { defaultIconSizeMedium } from '../types';

type Props = {
  size?: number;
};

// biome-ignore-start lint/plugin/no-hex-color: brand logo colors
export const GoogleIcon = ({ size = defaultIconSizeMedium }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={size}
    height={size}
    aria-hidden="true"
  >
    <path
      d="M15.68 8.18c0-.57-.05-1.11-.14-1.64H8v3.1h4.3a3.67 3.67 0 0 1-1.59 2.41v2h2.57c1.5-1.38 2.4-3.42 2.4-5.87Z"
      fill="#4285F4"
    />
    <path
      d="M8 16c2.16 0 3.97-.71 5.3-1.94l-2.58-2a4.8 4.8 0 0 1-7.17-2.52H.9v2.07A8 8 0 0 0 8 16Z"
      fill="#34A853"
    />
    <path
      d="M3.55 9.54A4.83 4.83 0 0 1 3.3 8c0-.54.09-1.06.25-1.54V4.39H.9A8 8 0 0 0 0 8c0 1.29.31 2.51.9 3.61l2.65-2.07Z"
      fill="#FBBC05"
    />
    <path
      d="M8 3.18c1.22 0 2.31.42 3.17 1.24l2.37-2.37A8 8 0 0 0 .9 4.39L3.55 6.46A4.77 4.77 0 0 1 8 3.18Z"
      fill="#EA4335"
    />
  </svg>
);
// biome-ignore-end lint/plugin/no-hex-color: brand logo colors
